import React from "react";
import { Button } from "./ui/button";

/**
 * Toggle between attributing leads by their first source vs latest source.
 *
 * - First — original capture source (never overwritten on re-enquiry)
 * - Latest — most recent inquiry source (defaults to first if no re-enquiry)
 *
 * Props:
 *   value    — 'latest' | 'first'
 *   onChange — fn(newValue)
 */
const SourceBasisToggle = ({ value = "latest", onChange }) => {
  const opts = [
    { key: "latest", label: "Latest" },
    { key: "first", label: "First" },
  ];
  return (
    <div
      className="inline-flex items-center gap-0.5 p-0.5 rounded-md border border-slate-200 bg-white"
      data-testid="source-basis-toggle"
      role="group"
      aria-label="Source attribution mode"
      title="How leads are attributed when grouping by source. Latest = use the most recent re-inquiry source. First = use the original capture source."
    >
      <span className="text-[10px] font-semibold text-slate-500 px-2 uppercase tracking-wide">Source</span>
      {opts.map((o) => (
        <Button
          key={o.key}
          type="button"
          size="sm"
          variant={value === o.key ? "default" : "ghost"}
          aria-pressed={value === o.key}
          className={`h-7 px-2.5 text-xs ${value === o.key ? "" : "text-slate-600"}`}
          onClick={() => onChange(o.key)}
          data-testid={`source-basis-${o.key}`}
        >
          {o.label}
        </Button>
      ))}
    </div>
  );
};

export default SourceBasisToggle;
